import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { RootStore } from '../data/store'
import { dateFormatter, DateFormatTypes, getDescriptionFromLOVValue, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { parseDate } from './fetchEosEntityDetails'

const responseParser = (response: any, ddData: any) => {
  const data = isSuccessResponse(response)
  if (data?.data?.findEntity?.entitySearchList?.length > 0) {
    const ret = {
      data:
        data?.data?.findEntity?.entitySearchList?.map((entityResp) => {
          const {
            group,
            entity: {
              parentEntityIdentificationNumber,
              subGroupIdentificationNumber,
              identificationNumber,
              activatedAt,
              businessProfile,
              status,
              reasonCode,
              reasonMessage,
              authorisedSignatoryDetails,
              gstDetails,
              settlementDetails,
              feePackageDetails,
              storeCodeDetails,
              contactDetails,
              ownerType,
              businessName,
              legalName,
              programCategoryDetails,
              addressDetails,
            },
          } = entityResp
          const authSignatoryAddressDetails = addressDetails?.find((item) => item?.addressRole === 'CRP')
          const businessAddressDetails = addressDetails?.find((item) => item?.addressRole === 'LOC')
          const businessContactDetais = contactDetails?.find((item) => item?.role === 'LOC')
          return {
            entityId: identificationNumber,
            applicationId: identificationNumber,
            taskInstanceId: '',
            requestType: 'UPDATE_PROFILE',
            createdAt: dateFormatter(activatedAt, DateFormatTypes.DATE_AM_PM),
            documentUploadId: '',
            applicationStatus: '',
            parentEntityId: parentEntityIdentificationNumber,
            onboardingChannel: getDescriptionFromLOVValue(
              ddData?.lovData,
              'SetupCompleteInd',
              settlementDetails?.setupCompleteInd,
            ),
            parentGroupId: group?.identificationNumber,
            parentSubGroupId: subGroupIdentificationNumber,
            parentType: parentEntityIdentificationNumber ? 'Entity' : 'SubGroup',
            nonEditableParentDetails: subGroupIdentificationNumber,
            status: getDescriptionFromLOVValue(ddData?.lovData, 'Status', status),
            reasonCode: getDescriptionFromLOVValue(ddData?.lovData, 'ReasonCode', reasonCode),
            reasonMessage,
            personalFirstName: businessContactDetais?.firstName,
            personalLastName: businessContactDetais?.lastName,
            personalMobileNumber: businessContactDetais?.mobileNumber,
            personalEmailId: businessContactDetais?.emailId,
            entityType: getDescriptionFromLOVValue(ddData?.lovData, 'OwnerType', ownerType),
            ownershipType: getDescriptionFromLOVValue(ddData?.lovData, 'OwnershipType', businessProfile?.ownershipType),
            businessChannel: getDescriptionFromLOVValue(
              ddData?.lovData,
              'BusinessChannel',
              businessProfile?.businessChannel,
            ),
            storeCode: storeCodeDetails?.storeCode,
            format: storeCodeDetails?.format,
            authSignatoryFirstName: authorisedSignatoryDetails?.authSigFirstname,
            authSignatoryLastName: authorisedSignatoryDetails?.authSigLastname,
            authSignatoryDateOfBirth: parseDate(authorisedSignatoryDetails?.authSigDOB ?? '', 'dd-mm-yyyy'),
            authSignatoryGender: getDescriptionFromLOVValue(
              ddData?.lovData,
              'Gender',
              authorisedSignatoryDetails?.authSigGender,
            ),
            authSignatoryPoi_docs_data: [],
            authSignatoryPoA_docs_data: [],
            authSignatoryAddressLine1: authSignatoryAddressDetails?.addressLine1,
            authSignatoryAddressLine2: authSignatoryAddressDetails?.addressLine2,
            authSignatoryPincode: authSignatoryAddressDetails?.pincode,
            authSignatoryCity: authSignatoryAddressDetails?.city,
            authSignatoryState: getDescriptionFromLOVValue(
              ddData?.lovData,
              'State',
              authSignatoryAddressDetails?.state,
            ),

            businessDisplayName: businessName,
            businessLegalName: legalName,
            businessPan: businessProfile?.businessPan,
            storeType: getDescriptionFromLOVValue(ddData?.lovData, 'StoreType', businessProfile?.storeType),
            mccCodeComponent: {
              businessLine: {
                key: '',
                value: '',
              },
              businessCategory: '',
              mccCode: businessProfile?.mccCode,
            },
            cinNumber: businessProfile?.cin ?? 'NA', //NA
            companyIncorporatedDate: businessProfile?.dateOfIncorporation, //NA
            yearsOfBusiness: getDescriptionFromLOVValue(
              ddData?.lovData,
              'YearsInBusiness',
              businessProfile?.yearsInBusiness,
            ),

            gstCategory: getDescriptionFromLOVValue(ddData?.lovData, 'MerchantCategory', gstDetails?.merchantCategory),

            gstinNumber: gstDetails?.gstin,
            confirmGstinNumber: gstDetails?.gstin,
            gstDealerCategory: getDescriptionFromLOVValue(
              ddData?.lovData,
              'GSTDealerCategory',
              gstDetails?.dealerCategory,
            ),
            typeOfBusiness: getDescriptionFromLOVValue(ddData?.lovData, 'BusinessType', gstDetails?.typeOfBusiness),
            businessDetailsPob_docs_data: [],
            premiseType: getDescriptionFromLOVValue(ddData?.lovData, 'PremiseType', businessProfile?.premiseType),

            addressLine1: businessAddressDetails?.addressLine1,
            addressLine2: businessAddressDetails?.addressLine2,
            pincode: businessAddressDetails?.pincode,
            city: businessAddressDetails?.city,
            state: getDescriptionFromLOVValue(ddData?.lovData, 'State', businessAddressDetails?.state),
            businessWebsite: businessProfile?.webAddress,
            landlineNumber: businessContactDetais?.landlineNumber ?? 'NA',
            dailyTransactionValue: getDescriptionFromLOVValue(
              ddData?.lovData,
              'DailyTransactionValue',
              businessProfile?.dailyTransactionValue,
              businessProfile?.dailyTransactionValue||"",
            ) ,
            dailyTransactionCount: getDescriptionFromLOVValue(
              ddData?.lovData,
              'DailyTransactionVolume',
              businessProfile?.dailyTransactionVolume,
              businessProfile?.dailyTransactionVolume||""
            ),
            //returnPolicy: '', //remove it

            bankAccountHolderName: settlementDetails?.beneficiaryName,
            settlementAccountNumber: settlementDetails?.accountNumber,
            confirmSettlementAccountNumber: settlementDetails?.accountNumber,
            ifscCode: settlementDetails?.ifsCode,
            account_proof_docType: 'Cancelled Cheque',
            canceled_check_docs_data: [],
            settlementFrequency: getDescriptionFromLOVValue(
              ddData?.lovData,
              'SettlementFrequencyESS',
              settlementDetails?.settlPlanId + '',
            ),
            settlementPlanId: (settlementDetails?.settlPlanId ?? '') + '',
            doc_upload_docs_data: [],
            feePackageId: (feePackageDetails?.feePkgId ?? '') + '',
            allowParentFeePackageId: feePackageDetails?.inheritParentFeePackage ? 'Yes' : 'No',
            listOfPrograms: programCategoryDetails?.[0]?.programId,
            referenceId: programCategoryDetails?.[0]?.referenceId,
          }
        }) ?? [],
      pagination: {
        size: data?.data?.findEntity?.page?.size,
        totalElements: data?.data?.findEntity?.page?.totalElements ?? 0,
        number: data?.data?.findEntity?.page?.number,
        totalPages: Math.ceil(data?.data?.findEntity?.page?.totalElements / data?.data?.findEntity?.page?.size),
      },
    }
    return ret
  }
  throw {
    message:
      response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
      response?.data?.errors?.[0]?.exception?.message ??
      response?.data?.errors?.[0]?.message,
  }
}

const getSearchRequestBody = (searchString: string, searchBy: string, pageNumber: number, pageSize: number) => {
  const searchByKeys: any = {
    'Entity ID': 'entityId',
    'Entity Name': 'legalName',
    'Mobile Number': 'mobileNumber',
    'Device Serial No.': 'deviceSerialNumber',
    VPA: 'midVpa',
    TID: 'tid',
    'Email Id': 'emailId',
    Pincode: 'pinCode',
    'Group ID': 'groupId',
    'SubGroup ID': 'subGroupId',
    'Store Code': 'storeCode',
  }

  const searchByKey = searchByKeys[searchBy]
  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
        page: pageNumber,
        size: pageSize,
      },
      entitySearchList: {
        group: {
          legalName: true,
          brandName: true,
          identificationNumber: true,
          status: true,
        },
        subGroup: {
          legalName: true,
          brandName: true,
          identificationNumber: true,
          status: true,
        },
        parent: {
          entityLevel: true,
          identificationNumber: true,
          businessName: true,
          status: true,
        },
        child: {
          entityLevel: true,
          identificationNumber: true,
          businessName: true,
          status: true,
        },
        identificationNumber: true,
        entity: {
          id: true,
          parentEntityIdentificationNumber: true,
          subGroupIdentificationNumber: true,
          identificationNumber: true,
          entityLevel: true,
          type: true,
          legalName: true,
          businessName: true,
          merchantOtpDate: true,
          deviceOtpDate: true,
          source: true,
          ownerType: true,
          name: true,
          oldStatus: true,
          defPostingEntity: true,
          activatedAt: true,
          terminatedAt: true,
          status: true,
          reasonCode: true,
          reasonMessage: true,
          businessProfile: {
            ownershipType: true,
            businessChannel: true,
            setUpLevel: true,
            premiseType: true,
            businessPan: true,
            webAddress: true,
            pharmacistName: true,
            storeType: true,
            pharmacyCouncilNumber: true,
            yearsInBusiness: true,
            annualRevenueSegment: true,
            id: true,
            mccCode: true,
            dailyTransactionVolume: true,
            dailyTransactionValue: true,
            marketPlace: true,
            merchIrctcFlag: true,
            agentId: true,
            cin: true,
            dateOfIncorporation: true,
          },
          contactDetails: {
            id: true,
            salutation: true,
            mobileNumber: true,
            firstName: true,
            middleName: true,
            lastName: true,
            gender: true,
            dob: true,
            dateOfBirth: true,
            entityContactAddress: {
              addressLine1: true,
              addressLine2: true,
              pincode: true,
              city: true,
              state: true,
              countryCode: true,
              addressType: true,
            },
            country: true,
            professionalTitle: true,
            phoneExt: true,
            phone1: true,
            phone2: true,
            landlineNumber: true,
            fax: true,
            emailId: true,
            websiteEmailId: true,
            websiteUrl: true,
            role: true,
            allowNotification: true,
            status: true,
            reasonCode: true,
            reasonMessage: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          authorisedSignatoryDetails: {
            authSigDOB: true,
            authSigFirstname: true,
            authSigMidname: true,
            authSigLastname: true,
            authSigGender: true,
            authSignDOC: true,
            authSigSalutation: true,
            locLangMerchdesc: true,
            id: true,
          },
          addressDetails: {
            id: true,
            addressType: true,
            pincode: true,
            state: true,
            countryCode: true,
            latitude: true,
            longitude: true,
            addressRole: true,
            status: true,
            reasonCode: true,
            reasonMessage: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            addressLine1: true,
            addressLine2: true,
            addressLine3: true,
            addressLine4: true,
            city: true,
            phone1: true,
            phone2: true,
            fax: true,
            emailAddr: true,
            stateAbbrev: true,
            geoCode: true,
          },
          gstDetails: {
            id: true,
            gstin: true,
            merchantCategory: true,
            dealerCategory: true,
            typeOfBusiness: true,
            gstStateCode: true,
            consentCode: true,
            consentVersion: true,
            consentAt: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            jioGST: true,
          },
          settlementDetails: {
            id: true,
            accountNumber: true,
            ifsCode: true,
            acctType: true,
            acctPostingType: true,
            entityAcctCurr: true,
            entityAcctId: true,
            setupCompleteInd: true,
            effectiveDate: true,
            beneficiaryName: true,
            settlementFrequency: true,
            settlPlanId: true,
            allowSettlement: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            settlementStatus: true,
          },
          feePackageDetails: {
            id: true,
            feePkgId: true,
            startDate: true,
            endDate: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            inheritParentFeePackage: true,
          },
          vpaDetails: {
            id: true,
            handle: true,
            is_default: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          programCategoryDetails: {
            id: true,
            programId: true,
            referenceId: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          kycDetailDetails: {
            id: true,
            documentCategory: true,
            documentName: true,
            documentNumber: true,
            docSubmitted: true,
            expiryDate: true,
            kycStatus: true,
            kycCreationDate: true,
            kycApprovalDate: true,
            kycRemarks: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          storeCodeDetails: {
            storeCode: true,
            format: true,
          },
        },
        terminalDetails: {
          terminalId: true,
          id: true,
          mid: true,
          deviceSerialNo: true,
          terminalType: true,
          mobileNumber: true,
          nickName: true,
          status: true,
          posMsgBrand: true,
          dailyTransactionValue: true,
          dailyTransactionVolume: true,
          terminalConfigurationDetails: {
            key: true,
            value: true,
          },
          vpaLinkings: {
            handle: true,
            id: true,
          },
          device: {
            deviceSerialNo: true,
            deviceStatus: true,
            id: true,
            deviceLinkingStatus: true,
            manufacturerName: true,
            entityIdLinkDate: true,
          },
        },
        deviceDetails: {
          deviceSerialNo: true,
          deviceStatus: true,
          deviceLinkingStatus: true,
          manufacturerName: true,
          entityIdLinkDate: true,
        },
      },
      page: {
        size: true,
        totalElements: true,
        totalPages: true,
        number: true,
      },
    },
  }

  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  return gqlQuery
}

const fetchSearchEntityNew = (
  searchString: string,
  searchBy: string,
  pageNumber: number,
  pageSize: number,
  ddData: any,
  abortController?: any,
) => {
  const { REACT_APP_ENV } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath:
      /* REACT_APP_ENV === 'pp' || */ REACT_APP_ENV === 'prod'
        ? APIEndPoints.searchEntityPPV2
        : getUrl(APIEndPoints.searchEntity),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: getHeaders(),
    body: getSearchRequestBody(searchString, searchBy, pageNumber, pageSize),
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp, ddData))
    .catch((error) => {
      throw error
    })
}

export { fetchSearchEntityNew }
